import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { IoCloseSharp } from 'react-icons/io5';
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md';
import { useHistory, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { PropsFromRedux } from '.';
// import disabledRedImg from '../../../../assets/icons/fadeout-radio.svg';
// import redImg from '../../../../assets/icons/red-round.svg';
import AlphaContext from '../../../../context/AlphaContext/AlphaContext';
import { ShipmentContext } from '../../../../context/AlphaContext/AlphaShipmentContext';

interface Props extends PropsFromRedux {
  alphaData: any;
  setAlphaData: Function;
}

interface Inputs {
  DeliveryMethod: 0 | 1;
}

const DeliveryMethod: React.FC<Props> = ({ hideModal, showModal, modal }) => {
  const { shipmentData, setShipmentData } = useContext(ShipmentContext);

  const totalProductCost = shipmentData?.total_product_cost;
  const grandTotal = shipmentData?.grand_total;
  const discountedShippingFee = shipmentData?.discounted_shipping_fee;
  const trxnRef = shipmentData?.trxnRef;
  const shippingFee =
    shipmentData &&
    shipmentData?.merchants_shipping_fees &&
    shipmentData?.merchants_shipping_fees[0];
  const newShippingFee =
    discountedShippingFee > 0 ? discountedShippingFee : shippingFee;
  // console.log(newShippingFee, discountedShippingFee, shippingFee);

  const history = useHistory();
  const closeModal = () => {
    hideModal();
  };

  const location = useLocation();

  const { alphaData, setAlphaData } = useContext(AlphaContext);
  const [delivery, setDelivery] = React.useState('');
  const [checkValue, setCheckValue] = React.useState(false);

  const modalProps = modal?.ownProps?.price;

  React.useEffect(() => {
    if (!location.pathname.includes('/alpha-product')) {
      setAlphaData(alphaData);
      closeModal();
    }
  }, [alphaData]);
  // console.log('alpha', alphaData);

  const selectDelivery = (selected: any) => {
    setDelivery(selected);
  };

  const onSubmit = async (data: Inputs) => {
    const alphaDetails = alphaData;
    // eslint-disable-next-line no-underscore-dangle
    const id = alphaDetails && alphaDetails._id;
    // console.log('alphaDetails', alphaDetails);

    let homeDeliverystatus;
    let deliveryOption;

    if (
      deliveryMethod !== null ||
      deliveryMethod !== undefined ||
      delivery !== ''
    ) {
      setCheckValue(true);
    }

    if (deliveryMethod == 0 || delivery === 'Door') {
      homeDeliverystatus = true;
      deliveryOption = 'HOMEDELIVERY';
      setValue('DeliveryMethod', 0);
    } else if (deliveryMethod == 1 || delivery === 'Center') {
      homeDeliverystatus = false;
      deliveryOption = 'SERVICECENTER';
      setValue('DeliveryMethod', 1);
    }

    let priceValue;
    const stationid = parseInt(alphaDetails.merchant_station_id, 10);
    if (modalProps) {
      priceValue = modalProps;
    } else {
      priceValue = alphaDetails.price;
    }

    const req = {
      IsHomeDelivery: homeDeliverystatus,
      // ShippingFee: 0,
      ShippingFee: newShippingFee,

      // DeliveryPrice: 0,
      DeliveryPrice: newShippingFee,
      Merchants: [
        {
          user_id: alphaDetails.createdBy,
          store_id: alphaDetails?.store?.storeId || '',
          CustomerCode: 'ACC001164',
          PaymentType: 'Cash',
          CashOnDeliveryAmount: 0,
          IsCashOnDelivery: false,
          PreShipmentItems: [
            {
              buyer_id: '',
              ItemName: alphaDetails.productName,
              // shippingFee: priceValue,
              ItemType: 'Normal',
              product_id: id,
              Quantity: alphaDetails.Quantity,
              ShipmentType: 'Regular',
              size: alphaDetails.Size,
              SpecialPackageId: '0',
              // Value: priceValue,
              product_image: alphaDetails.front_view,
              Weight: alphaDetails.weight,
              WeightRange: '0',
              color: alphaDetails.Color,

              ShippingFee: newShippingFee,
              ItemValue: totalProductCost,
              Value: totalProductCost,
            },
          ],
          SenderAddress: alphaDetails.address,
          SenderEmail: '',
          SenderLocality: alphaDetails.locality,
          SenderLocation: {
            Latitude: alphaDetails.lat,
            Longitude: alphaDetails.long,
          },
          SenderName:
            alphaDetails.merchant_first_name + alphaDetails.merchant_last_name,
          SenderPhoneNumber: alphaDetails.merchant_phone_number,
          SenderStationId: alphaDetails.merchant_station_id,
        },
      ],
      PaymentType: 'Cash',
      PickupOptions: deliveryOption,
      price: alphaDetails.price,
      ReceiverAddress: '',
      ReceiverEmail: '',
      ReceiverLocation: {},
      ReceiverName: '',
      ReceiverPhoneNumber: '',
      ReceiverStationId: 0,
      // totalCost: 0,
      // trxnRef: '',
      totalCost: grandTotal,
      trxnRef,
      trxn_ref: '',
      VehicleType: `${
        alphaDetails.vehicleType
          ? alphaDetails.vehicleType.toUpperCase()
          : 'BIKE'
      }`,
    };

    if (req) {
      setAlphaData(req);
      showModal({
        component: 'UserDetails',
        modalProps: {
          contentLabel: 'User Details modal',
        },
      });
    }
  };

  const { handleSubmit, control, errors, reset, watch, register, setValue } =
    useForm<Inputs>({});

  const deliveryMethod: any = watch('DeliveryMethod');

  return (
    <div className="relative w-full px-2 py-10 bg-white lg:px-20">
      {alphaData && (
        <form
          className="w-full max-w-lg mx-auto my-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          <button type="button" aria-label="Close" onClick={closeModal}>
            <IoCloseSharp className="sticky top-0 text-2xl cursor-pointer sm:absolute left-full sm:left-auto sm:right-5 sm:top-5" />
          </button>
          <div className="flex items-center justify-center w-full my-2 border-b border-gray-300 ">
            <h3 className="pb-4 text-gray-500">Checkout</h3>
          </div>
          <div className="w-full px-4">
            <div className="w-full my-6">
              <h2 className="mb-1 font-medium text-black text-md">
                Select a delivery method
              </h2>
            </div>
            <div className="w-full my-4 border-b border-gray-400">
              <div className="flex w-full">
                <label htmlFor="0" className="flex justify-between mr-6 -mt-4">
                  <input
                    name="DeliveryMethod"
                    value="0"
                    id="0"
                    ref={register}
                    disabled
                    // defaultChecked={true}
                    className="hidden"
                    type="radio"
                  />
                  <span className="inline-flex items-center">
                    {deliveryMethod == 0 || delivery == 'Door' ? (
                      <MdRadioButtonChecked className="absolute ml-4 -mt-8 text-2xl text-pink-600" />
                    ) : (
                      <MdRadioButtonUnchecked
                        className="absolute ml-4 -mt-8 text-2xl text-gray-400"
                        onClick={() => selectDelivery('Door')}
                      />
                    )}
                  </span>
                </label>

                <Link
                  to={{ pathname: '' }}
                  className="w-full"
                  onClick={() => selectDelivery('Door')}
                >
                  <div className="p-4 mx-4 pointer-events-auto">
                    <h3 className="mb-1 font-semibold text-md ">
                      Door Delivery
                    </h3>
                    <p>
                      Choose this option to have your package delivered directly
                      to an address of your choice
                    </p>
                  </div>
                </Link>
              </div>
            </div>
            <div className="w-full my-4">
              <div className="flex w-full ">
                <label htmlFor="1" className="flex justify-between mr-6 -mt-4">
                  <input
                    name="DeliveryMethod"
                    value="1"
                    id="1"
                    ref={register}
                    disabled
                    // defaultChecked={true}
                    className="hidden"
                    type="radio"
                  />
                  <span className="inline-flex items-center">
                    {deliveryMethod == 1 || delivery == 'Center' ? (
                      <MdRadioButtonChecked className="absolute ml-4 -mt-12 text-2xl text-pink-600" />
                    ) : (
                      <MdRadioButtonUnchecked
                        className="absolute ml-4 -mt-12 text-2xl text-gray-400"
                        onClick={() => selectDelivery('Center')}
                      />
                    )}
                  </span>
                </label>
                <Link
                  to={{ pathname: '' }}
                  className="w-full"
                  onClick={() => selectDelivery('Center')}
                >
                  <div className="p-4 mx-4 -mt-4 pointer-events-auto">
                    <h3 className="mb-1 font-semibold text-md">
                      GIGL Experience Center{' '}
                      <b className="text-sm text-green-600">
                        (saves you ₦1000 - ₦3000)
                      </b>
                    </h3>
                    <p>
                      Choose this option to pick up your item(s) from any of our
                      experience center closest to you.
                    </p>
                  </div>
                </Link>
              </div>
            </div>
            <button
              // className="w-full py-3 mt-6 text-sm font-medium text-white bg-gray-400 rounded hover:bg-black"
              type="submit"
              disabled={delivery == ''}
              className="w-full py-3 mt-6 text-sm font-medium text-white bg-black rounded"
            >
              Continue
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default DeliveryMethod;
